module.exports = __webpack_public_path__ + "img/logo.7bc8e462.png";